import { GoogleTagManagerService } from './../../services/analytics/google-tag-manager.service';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import $ from 'jquery';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { MdDialog, MdDialogRef } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { UserFeatureService } from '../../services/user-feature/user-feature.service';
import { UserService } from 'app/services/user/user.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { DialogSwitchCompanyComponent } from './dialog-switch-company/dialog-switch-company.component';
import { AuthenticationService } from 'app/services/authentication/authentication.service';
import { UserModel, UserSetting } from 'app/model/user.model';
import { FeatureType, CompanyFeatureConfigType, Language } from 'app/model/constant';
import { CompanyFeatures, CompanyFeaturesDetail } from 'app/model/menu/companyFeatures';
import { DialogAlertComponent } from '../modal/dialog-alert/dialog-alert.component';
import { configFlight, accountFrontend, configCarRental, useHomeV2, redirectURIV2 } from 'environments/properties';
import { FleetService } from 'app/services/fleet/fleet.service';
import { Option } from 'app/model/dropdown/dropdown-option-model';
import { Currency } from 'app/model/currency.model';
import { CurrencyService } from 'app/services/currency/currency.service';
import { DialogSwitchLangCurrencyComponent } from './dialog-switch-lang-currency/dialog-switch-lang-currency.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss']
})
export class MenuBarComponent implements OnInit, OnDestroy {

  public LANGUAGE = Language;
  public useHomeV2 = useHomeV2;
  public redirectURIV2 = redirectURIV2;

  private _firstLandingState: string;
  private _landingPageState: string;
  public user: any;
  public user_img: string;
  public languageList: Option[] = [];
  public tempLanguage: string;
  public currentLanguage: string;
  public currencyList: Observable<Currency[]>;
  public tempCurrency: string;
  public currentCurrency: string;
  public companies = [];
  public companyFeatures = [];
  public displayFlight: boolean;
  public displayCarRental: boolean;
  public displayMoreService = true;
  public displayCoWorkingSpace = false;
  public isShowCompanies = false;

  private isMobileDisplayMenu = false;
  public isfirstSection = false;
  public isLogin = false;
  public isShowListLanguageCurrency = false;
  public showApprovalList = false;
  public showPermission = true;
  public showFleetMenu = true;
  public showPreApprovalRequester = false;
  public showPreApprovalApprover = false;
  public selectedCompanyId: number;

  public ACT_LOGO_DEFAULT: string;
  public ACT_LOGO_DEFAULT_WHITE: string;
  public ACT_LOGO_DEFAULT_MOBILE: string;

  public logoPath: string;
  public logoWhitePath: string;
  public logoMobilePath: string;
  private returnUrl: string;
  public allowBookWork = true;

  private userSubscription: Subscription;
  private userSettingSubscription: Subscription;
  private appConfigSubscription: Subscription;
  private authServiceSubscription: Subscription;
  private currencySubscription: Subscription;
  private dialogSwitchLanguageCurrencySubscription: Subscription;

  public features = [
    FeatureType.ALLOW_CREDIT_TERMS,
    FeatureType.ALLOW_LIMIT_BUDGET,
    FeatureType.ALLOW_LIMIT_ROOM,
    FeatureType.ALLOW_MULTI_PAYMENT,
    FeatureType.ALLOW_SHARE_BUDGET,
    CompanyFeatureConfigType.CONFIG_CHECKOUT_3,
    FeatureType.ALLOW_CORPORATE_FLEET,
    FeatureType.ALLOW_MULTI_PAYMENT_CORPORATE_FLEET,
  ];

  @Input() theme = '';

  @Input() notFoundPage = false;

  @Input() showMenu = true;

  @Input() isShowCurrency = true;

  @Input('firstLandingState')
  set firstLandingState(firstLandingState: string) {
    this._firstLandingState = firstLandingState ? firstLandingState : '';
  }

  @Input('landingPageState')
  set landingPageState(landingPageState: string) {
    this._landingPageState = landingPageState ? landingPageState : '';
    this.isfirstSection = this._landingPageState === this._firstLandingState;
  }

  @Output('onMobileToggleMenuBar') mobileToggleMenuBar = new EventEmitter(); // tslint:disable-line

  constructor(
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService,
    private userService: UserService,
    private userFeatureService: UserFeatureService,
    private authenticationService: AuthenticationService,
    public dialog: MdDialog,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private fleetService: FleetService,
    private googleTagManagerService: GoogleTagManagerService,
    private currencyService: CurrencyService,
  ) { }

  ngOnInit() {
    this.languageList = this.appConfigService.getLanguageList();
    this.user = this.userService.getUser(false);
    if (this.user && this.user.companyId) {
      this.selectedCompanyId = this.user.companyId;
    }
    this.showApprovalList = this.userFeatureService.canShowApprovalList();
    this.displayFlight = configFlight.displayFlight && this.displayFlightFeature();
    this.displayCarRental = configCarRental.displayCarRental && this.displayCarRentalFeature();
    this.showPermission = this.displayPermissionMenuFeature();
    this.allowBookWork = this.isAllowBookWorkPurpose();
    this.showPreApprovalRequester = this.userFeatureService.enablePreApprovalRequester();
    this.showPreApprovalApprover = this.userFeatureService.enablePreApprovalApprover();

    let countService = 1; // default accommodation;
    this.displayFlight && countService++;
    this.displayCarRental && countService++;
    if(countService >= 3) {
      this.displayMoreService =  true;
    } else if (countService == 2) {
      this.displayCoWorkingSpace = true;
      this.displayMoreService =  true;
    } else {
      this.displayCoWorkingSpace = true;
      this.displayMoreService =  false;
    }

    if (this.user) {
      if (this.user.ImageUser === null) {
        this.user_img = 'url("assets/images/header/user_default_display.png")';
      } else {
        this.user_img = `url("${this.user.ImageUser}")`;
      }
    }

    this.isLogin = this.user ? true : false;
    this.currentLanguage = this.appConfigService.getLanguage();
    this.tempLanguage = this.currentLanguage;

    this.currentCurrency = this.currencyService.getCurrencyCode();
    this.tempCurrency = this.currentCurrency;

    this.currencySubscription = this.currencyService.getCurrencyObs().subscribe(currency => {
      this.currentCurrency = currency.currencyCode;
      this.tempCurrency = this.currentCurrency;
    });

    this.userSubscription = this.userService.getUserObs().subscribe(user => {
      this.user = this.userService.getUser(false);
    });

    this.activeRoute.queryParams.subscribe((params) => {
      if (params.returnUrl) {
        this.returnUrl = params.returnUrl;
      }
    });

    this.setLogoPath();
  }

  ngOnDestroy() {
    this.utilitiesService.unlockBody();
    this.userSubscription && this.userSubscription.unsubscribe();
    this.userSettingSubscription && this.userSettingSubscription.unsubscribe();
    this.appConfigSubscription && this.appConfigSubscription.unsubscribe();
    this.authServiceSubscription && this.authServiceSubscription.unsubscribe();
    this.currencySubscription && this.currencySubscription.unsubscribe();
  }

  goToTop(e: Event) {
    this.goToHome(null);
    if (window.matchMedia('(max-width: 1024px)').matches) {
      let $body = $("html, body");
      $body.stop().animate({ scrollTop: 0 }, 500);
    } else {
      $('#fullpage').fullpage.moveTo(1);
    }
  }

  goToHome(e: Event) {
    if (useHomeV2) {
      window.location.href = redirectURIV2;
    } else {
      if (document.location.pathname !== '/') {
        this.router.navigateByUrl('/?lang=' + this.appConfigService.getLanguage());
      }
      if (window.matchMedia('(max-width: 767px)').matches) {
        this.handleBlurMenuBar();
      }
    }
  }

  goToMice(e: Event) {
    if (document.location.pathname !== '/mice') {
      this.router.navigateByUrl('/mice?lang=' + this.appConfigService.getLanguage());
    }
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.handleBlurMenuBar();
    }
  }

  goToMyBudget(e: Event) {
    if (document.location.pathname !== '/permission') {
      this.router.navigateByUrl('/permission?lang=' + this.appConfigService.getLanguage());
    }
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.handleBlurMenuBar();
    }
  }

  goToFleetCard(e: Event) {
    if (document.location.pathname !== '/fleet-card') {
      this.router.navigateByUrl('/fleet-card?lang=' + this.appConfigService.getLanguage());
    }
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.handleBlurMenuBar();
    }
  }

  goToProfile(e: Event) {
    if (document.location.pathname !== '/profile') {
      this.router.navigateByUrl('/profile?lang=' + this.appConfigService.getLanguage());
    }
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.handleBlurMenuBar();
    }
  }

  goToBooking(e: Event) {
    if (document.location.pathname !== '/booking') {
      this.router.navigateByUrl('/booking?lang=' + this.appConfigService.getLanguage());
    }
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.handleBlurMenuBar();
    }
  }

  goToApproval(e: Event) {
    if (document.location.pathname !== '/approval') {
      this.router.navigateByUrl('/approval?lang=' + this.appConfigService.getLanguage());
    }
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.handleBlurMenuBar();
    }
  }

  goToShareBudget(e: Event) {
    if (document.location.pathname !== '/share-budget-code') {
      this.router.navigateByUrl('/share-budget-code?lang=' + this.appConfigService.getLanguage());
    }
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.handleBlurMenuBar();
    }
  }

  goToSetting(e: Event) {
    if (document.location.pathname !== '/setting') {
      this.router.navigateByUrl('/setting?lang=' + this.appConfigService.getLanguage());
    }
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.handleBlurMenuBar();
    }
  }

  getLang() {
    return this.appConfigService.getLanguage();
  }

  handleToggleMenuBar() {
    this.isMobileDisplayMenu = !this.isMobileDisplayMenu;
    this.mobileToggleMenuBar.emit({ 'isMobileDisplayMenu': this.isMobileDisplayMenu });

    if (this.isMobileDisplayMenu) {
      $('html').addClass('-open-sidemenu');
      this.utilitiesService.lockBody();
    } else {
      $('html').removeClass('-open-sidemenu');
      this.utilitiesService.unlockBody();
    }
    this.user !== undefined && this.onGetUserCompanies();
  }

  handleBlurMenuBar() {
    this.isMobileDisplayMenu = false;
    this.mobileToggleMenuBar.emit({ 'isMobileDisplayMenu': this.isMobileDisplayMenu });
    $('html').removeClass('-open-sidemenu');
    this.utilitiesService.unlockBody();
  }

  onClickLogin(e: Event) {
    let queryParams: any = this.authenticationService.generateAuthorizeRequest();
    if (this.returnUrl) {
      queryParams = {
        ...queryParams,
        returnUrl: encodeURIComponent(this.returnUrl)
      };
    }
    window.location.href = encodeURI(`${accountFrontend}${this.utilitiesService.objectToQueryString(queryParams)}`);
  }

  handleShowLanguageCurrency(show: boolean) {
    this.isShowListLanguageCurrency = show;
    if (this.isShowListLanguageCurrency) {
      this.currencyList = this.currencyService.getCurrencyList();
      $('.side-menu-language-currency-overlay').addClass('-open');
      setTimeout(() => {
        $('.side-menu-language-currency-container').addClass('-open-language-currency');
      });
    } else {
      $('.side-menu-language-currency-container').removeClass('-open-language-currency');
      setTimeout(() => {
        $('.side-menu-language-currency-overlay').removeClass('-open');
        this.tempLanguage = this.currentLanguage;
        this.tempCurrency = this.currentCurrency;
      }, 400);
    }
  }

  handleChangeLanguage(languageCode: string) {
    this.tempLanguage = languageCode;
  }

  handleChangeCurrency(currencyCode: string) {
    this.tempCurrency = currencyCode;
  }

  handleSubmitLanguageCurrency() {
    this.appConfigService.setLanguage(this.tempLanguage);
    this.currencyService.setCurrency(this.tempCurrency);
    this.updateUserSetting(this.tempLanguage, this.tempCurrency);
    this.currentLanguage = this.tempLanguage;
    this.handleShowLanguageCurrency(false);
    this.handleToggleMenuBar();
  }

  handleLogoutButton(e: Event) {
    this.userService.logout();
    $('html').removeClass('-open-sidemenu');
  }

  onClickCompany(companyId: number) {
    const user = new UserModel();
    user.companyId = companyId;

    const companyFeaturesDetail = new CompanyFeaturesDetail;

    if (companyId !== this.selectedCompanyId) {
      this.authServiceSubscription && this.authServiceSubscription.unsubscribe();
      this.authServiceSubscription = this.authenticationService.getUserFeature(null, user, this.features).subscribe((features: CompanyFeatures[]) => {
        companyFeaturesDetail.companyId = companyId;
        companyFeaturesDetail.companyTitleTh = this.companies.find(f => f.companyId === companyId).companyTitleTh;
        companyFeaturesDetail.companyTitleEn = this.companies.find(f => f.companyId === companyId).companyTitleEn;
        features.map(f => {
          switch (f.feature) {
            case FeatureType.ALLOW_CREDIT_TERMS:
              companyFeaturesDetail.paymentMethod = f.allow ? 'CREDIT_TERMS' : 'CREDIT_CARD';
              companyFeaturesDetail.allowCreditTerm = f.allow ? f.allow : null;
              break;
            case FeatureType.ALLOW_LIMIT_BUDGET:
              companyFeaturesDetail.limitBudget = f.allow;
              companyFeaturesDetail.normalBudget = f.allow && f.data && f.data.amount ? f.data.amount : null;
              companyFeaturesDetail.normalBudgetPerMonth = f.allow && f.data && f.data.amountPerMonth ? f.data.amountPerMonth : null;
              companyFeaturesDetail.normalBudgetPerYear = f.allow && f.data && f.data.amountPerYear ? f.data.amountPerYear : null;
              companyFeaturesDetail.normalBudgetUnlimited = f.allow && f.data && f.data.budgetUnlimited;
              companyFeaturesDetail.normalCoBudget = f.allow && f.data && f.data.coBudget ? f.data.coBudget : null;
              companyFeaturesDetail.normalCoBudgetUnlimited = f.allow && f.data && f.data.coBudgetUnlimited != null ? f.data.coBudgetUnlimited : null;
              if (f.allow && f.data && f.data.travelPolicyList) {
                companyFeaturesDetail.travelPolicyList = f.data.travelPolicyList;
              } else {
                companyFeaturesDetail.travelPolicyList = null;
              }
              break;
            case CompanyFeatureConfigType.CONFIG_CHECKOUT_3:
              companyFeaturesDetail.taxAddress = this.getLang() === 'th' ? f.data.taxAddressTh : f.data.taxAddressEn;
              companyFeaturesDetail.taxId = f.data.taxId;
              companyFeaturesDetail.taxName = this.getLang() === 'th' ? f.data.taxNameTh : f.data.taxNameEn;
              break;
            case FeatureType.ALLOW_LIMIT_ROOM:
              companyFeaturesDetail.allowLimitRoom = f.allow ? f.allow : null;
              companyFeaturesDetail.limitRoom = f.data.quantity;
              break;
            case FeatureType.ALLOW_MULTI_PAYMENT:
              companyFeaturesDetail.multiPayment = f.allow ? f.allow : null;
              break;
            case FeatureType.ALLOW_SHARE_BUDGET:
              companyFeaturesDetail.shareBudget = f.allow ? f.allow : null;
              break;
            case FeatureType.ALLOW_CORPORATE_FLEET:
              companyFeaturesDetail.allowCorporateFleet = f.allow ? f.allow : null;
              break;
            case FeatureType.ALLOW_MULTI_PAYMENT_CORPORATE_FLEET:
              companyFeaturesDetail.allowMultiPaymentCorporateFleet = f.allow ? f.allow : null;
              break;
          }
        });
        this.dialog.open(DialogSwitchCompanyComponent, {
          data: companyFeaturesDetail
        }).afterClosed().subscribe((res) => {
          if (res && res === 'success') {
            this.selectedCompanyId = companyId;
          }
          this.handleBlurMenuBar();
        });
      }, error => {
        const dialogAlertRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent);
        dialogAlertRef.componentInstance.alertText = this.appConfigService.getTranslate('system-error');
        dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
        dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
      });
    } else {
      this.handleBlurMenuBar();
    }
  }

  onGetUserCompanies() {
    this.userSubscription && this.userSubscription.unsubscribe();
    this.userSubscription = this.userService.getAllCompanyUser().subscribe(companies => {
      this.isShowCompanies = true;
      this.companies = companies;
      this.isShowCompanies = this.companies.length !== 0;
    });
  }

  setLogoPath() {
    const { ActLogoPath, ActLogoWhitePath, ActLogoMobilePath } = this.appConfigService.getActLogoPath();
    const { ActDefaultLogoPath, ActDefaultLogoWhitePath, ActDefaultLogoMobilePath } = this.appConfigService.getActDefaultLogoPath();
    this.logoPath = ActLogoPath;
    this.logoWhitePath = ActLogoWhitePath;
    this.logoMobilePath = ActLogoMobilePath;
    this.ACT_LOGO_DEFAULT = ActDefaultLogoPath;
    this.ACT_LOGO_DEFAULT_WHITE = ActDefaultLogoWhitePath;
    this.ACT_LOGO_DEFAULT_MOBILE = ActDefaultLogoMobilePath;
  }

  onClickFlight() {
    const userInfo = this.authenticationService.getUserInfo();
    const redirectUrl = configFlight.redirectURI + (!!userInfo.companyId ? `?companyId=${userInfo.companyId}` : ``);
    window.open(redirectUrl, '_blank');
  }

  onClickCarRental() {
    const userInfo = this.authenticationService.getUserInfo();
    const redirectUrl = configCarRental.redirectURI + (!!userInfo.companyId ? `?companyId=${userInfo.companyId}` : ``);
    window.open(redirectUrl, '_blank');
  }

  displayCarRentalFeature() {
    const allowCarRentalCreditTerms = this.userService.getUserFeature(FeatureType.ALLOW_RENT_CAR_CREDIT_TERMS, true);
    const allowCarRentalOtherPayment = this.userService.getUserFeature(FeatureType.ALLOW_RENT_CAR_OTHER_PAYMENTS, true);
    return (allowCarRentalCreditTerms && allowCarRentalCreditTerms.allow) || (allowCarRentalOtherPayment && allowCarRentalOtherPayment.allow);
  }

  displayFlightFeature() {
    const allowBookFlight = this.userService.getUserFeature(FeatureType.ALLOW_BOOK_FLIGHT, true);
    return allowBookFlight && allowBookFlight.allow;
  }

  displayPermissionMenuFeature() {
    const featureAllowDisplayPermission = this.userService.getUserFeature(FeatureType.ALLOW_DISPLAY_PERMISSION_MENU, true);
    return featureAllowDisplayPermission && featureAllowDisplayPermission.allow !== undefined ? featureAllowDisplayPermission.allow : this.showPermission;
  }

  isAllowBookWorkPurpose() {
    const featureAllowBookWorkPurpose = this.userService.getUserFeature(FeatureType.ALLOW_BOOK_WORK_PURPOSE, true);
    return featureAllowBookWorkPurpose && featureAllowBookWorkPurpose.allow !== undefined ? featureAllowBookWorkPurpose.allow : this.allowBookWork;
  }

  openTabCoWorkingSpace() {
    this.googleTagManagerService.emitEvent('Co-working space', 'click', 'click', 1, 'click menu');
    if(this.appConfigService.getLanguage() == 'th') {
      window.open('https://www.truespaceth.com/meeting_ascend_th/');
    } else {
      window.open('https://www.truespaceth.com/en/meeting_ascend_en/');
    }
  }

  openDialogLanguageCurrency() {
    this.dialogSwitchLanguageCurrencySubscription && this.dialogSwitchLanguageCurrencySubscription.unsubscribe();
    this.dialogSwitchLanguageCurrencySubscription = this.dialog.open(DialogSwitchLangCurrencyComponent).afterClosed().subscribe((res) => {
      if (res) {
        this.currentLanguage = res.language;
        this.appConfigService.setLanguage(res.language);
        this.currencyService.setCurrency(res.currency);
        this.updateUserSetting(res.language, res.currency);
      }
    });
  }

  private updateUserSetting(language: string, currency: string) {
    if (this.isLogin) {
      const request: UserSetting = {
        lang: language,
        currency: currency,
      }
      this.userSettingSubscription && this.userSettingSubscription.unsubscribe();
      this.userSettingSubscription = this.userService.updateUserSetting(this.user.userId, request).subscribe({
        next: (response) => {},
        error: (error) => {}
      });
    }
    this.authenticationService.saveLanguageCurrencyCookie(language, currency);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/menu-bar/menu-bar.component.ts